<template><span></span></template>
<script>export default {
    created() {
    	let kundoScript = document.createElement('script');
        kundoScript.setAttribute('id', 'kundoScript');
        kundoScript.setAttribute('src', 'https://kb.kundo.se/js/embed.js');
        document.head.appendChild(kundoScript);
    }
}</script>